import React, { useState, useEffect } from "react";
import { supabase } from "../../supabase-client";
import {
   Eye,
   Check,
   X,
   Mail,
   Calendar,
   User,
   Send,
   MessageSquare,
} from "lucide-react";
import Enviarmail from "../../components/enviarmail";

export default function Contactos() {
   const [contactos, setContactos] = useState([]);
   const [loading, setLoading] = useState(true);
   const [submitting, setSubmitting] = useState(false);
   const [selectedContacto, setSelectedContacto] = useState(null);
   // const [showForm, setShowForm] = useState(false);
   const [showResponseForm, setShowResponseForm] = useState(false);
   const [filterResponse, setFilterResponse] = useState("todos");

   // Form state
   // const [formData, setFormData] = useState({
   //    nombre: "",
   //    email: "",
   //    consulta: "",
   //    response: false,
   // });

   // Response form state
   const [responseData, setResponseData] = useState({
      subject: "",
      message: "",
      contactoId: null,
   });

   // Fetch contactos from database
   const fetchContactos = async () => {
      setLoading(true);
      try {
         const { data, error } = await supabase
            .from("contacto")
            .select("*")
            .order("created_at", { ascending: false });

         if (error) {
            console.error("Error fetching contactos:", error);
            alert("Error al cargar los contactos");
            return;
         }

         setContactos(data || []);
      } catch (err) {
         console.error("Error:", err);
         alert("Error al conectar con la base de datos");
      }
      setLoading(false);
   };

   // Toggle response status
   const toggleResponse = async (contactoId, currentResponse) => {
      try {
         const { error } = await supabase
            .from("contacto")
            .update({
               response: !currentResponse,
               updated_at: new Date().toISOString(),
            })
            .eq("id", contactoId);

         if (error) {
            console.error("Error updating response:", error);
            alert("Error al actualizar el estado");
            return;
         }

         // Update local state
         setContactos((prev) =>
            prev.map((contacto) =>
               contacto.id === contactoId
                  ? { ...contacto, response: !currentResponse }
                  : contacto
            )
         );
      } catch (err) {
         console.error("Error:", err);
         alert("Error al actualizar el estado");
      }
   };

   // Open response form with prefilled data
   const openResponseForm = (contacto) => {
      setResponseData({
         subject: `Re: Consulta sobre ${contacto.consulta.substring(0, 30)}...`,
         message: `Hola ${contacto.nombre},\n\nGracias por tu consulta. `,
         contactoId: contacto.id,
      });
      setShowResponseForm(true);
      setSelectedContacto(null); // Close detail modal if open
   };

   // Handle response form changes
   const handleResponseChange = (e) => {
      const { name, value } = e.target;
      setResponseData((prev) => ({
         ...prev,
         [name]: value,
      }));
   };

   // Send response (simulate email sending and save response)
   const sendResponse = async (e) => {
      e.preventDefault();
      console.log('responseData: ', responseData);
      if (!responseData.subject.trim() || !responseData.message.trim()) {
         alert("Asunto y mensaje son obligatorios");
         return;
      }

      setSubmitting(true);

      try {
         // Find the contact
         const contacto = contactos.find(
            (c) => c.id === responseData.contactoId
         );
         if (!contacto) {
            alert("Contacto no encontrado");
            setSubmitting(false);
            return;
         }

         // Here you would typically integrate with an email service
         // For now, we'll simulate the email sending and save the response
         const resp = await Enviarmail({
            aquien: contacto.email,
            reply_to: contacto.email,
            asunto: "Diego Curutchet",
            texto: responseData.message,
         });
         
         if (!resp) {
            console.error("Error sending email");
         }

         // Save response to database (optional - you can create a 'respuestas' table)
         const { error: responseError } = await supabase
            .from("respuestas")
            .insert([
               {
                  contacto_id: responseData.contactoId,
                  subject: responseData.subject,
                  message: responseData.message,
                  sent_at: new Date().toISOString(),
                  sent_to: contacto.email,
               },
            ]);
            
         if (responseError) {
            console.error("Error Insert Respuestas " + responseError);
         }

         // Update contact as responded
         const { error: updateError } = await supabase
            .from("contacto")
            .update({
               response: true,
               updated_at: new Date().toISOString(),
            })
            .eq("id", responseData.contactoId);

         if (updateError) {
            console.error("Error updating contact:", updateError);
         }

         // Update local state
         setContactos((prev) =>
            prev.map((contacto) =>
               contacto.id === responseData.contactoId
                  ? { ...contacto, response: true }
                  : contacto
            )
         );

         // Reset form and close modal
         setResponseData({
            subject: "",
            message: "",
            contactoId: null,
         });
         setShowResponseForm(false);

         // Show success message with email client option
         const mailtoLink = `mailto:${
            contacto.email
         }?subject=${encodeURIComponent(
            responseData.subject
         )}&body=${encodeURIComponent(responseData.message)}`;

         if (
            window.confirm(
               `Respuesta preparada correctamente.\n\n¿Deseas abrir tu cliente de email para enviar la respuesta a ${contacto.email}?`
            )
         ) {
            window.location.href = mailtoLink;
         }
      } catch (err) {
         console.error("Error sending response:", err);
         alert("Error al procesar la respuesta");
      }

      setSubmitting(false);
   };

   // Filter contactos by response status
   const filteredContactos =
      filterResponse === "todos"
         ? contactos
         : contactos.filter((contacto) =>
              filterResponse === "respondidos"
                 ? contacto.response
                 : !contacto.response
           );

   // Format date
   const formatDate = (dateString) => {
      return new Date(dateString).toLocaleString("es-AR", {
         year: "numeric",
         month: "2-digit",
         day: "2-digit",
         hour: "2-digit",
         minute: "2-digit",
      });
   };

   useEffect(() => {
      fetchContactos();
   }, []);

   if (loading) {
      return (
         <div className="p-6 text-center">
            <h1 className="text-3xl font-bold mb-4">Contactos</h1>
            <div className="flex items-center justify-center">
               <div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent"></div>
               <span className="ml-2">Cargando contactos...</span>
            </div>
         </div>
      );
   }

   return (
      <div className="p-6 max-w-7xl mx-auto">
         <div className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-bold">Gestión de Contactos</h1>
            <div className="flex gap-3">
               <button
                  onClick={fetchContactos}
                  className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
               >
                  🔄 Actualizar
               </button>
            </div>
         </div>

         {/* Statistics */}
         <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="bg-blue-50 p-4 rounded-lg text-center border">
               <div className="text-3xl font-bold text-blue-600">
                  {contactos.length}
               </div>
               <div className="text-sm text-blue-800">Total Contactos</div>
            </div>
            <div className="bg-green-50 p-4 rounded-lg text-center border">
               <div className="text-3xl font-bold text-green-600">
                  {contactos.filter((c) => c.response).length}
               </div>
               <div className="text-sm text-green-800">Respondidos</div>
            </div>
            <div className="bg-yellow-50 p-4 rounded-lg text-center border">
               <div className="text-3xl font-bold text-yellow-600">
                  {contactos.filter((c) => !c.response).length}
               </div>
               <div className="text-sm text-yellow-800">Pendientes</div>
            </div>
         </div>

         {/* Filters */}
         <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
               Filtrar por estado:
            </label>
            <select
               value={filterResponse}
               onChange={(e) => setFilterResponse(e.target.value)}
               className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
               <option value="todos">Todos</option>
               <option value="pendientes">Pendientes de respuesta</option>
               <option value="respondidos">Respondidos</option>
            </select>
         </div>

         {/* Contactos Table */}
         {filteredContactos.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
               {filterResponse === "todos"
                  ? "No hay contactos registrados"
                  : `No hay contactos ${filterResponse}`}
            </div>
         ) : (
            <div className="bg-white rounded-lg shadow overflow-hidden">
               <table className="w-full">
                  <thead className="bg-gray-50">
                     <tr>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           ID
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Fecha
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Nombre
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Email
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Consulta
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Estado
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Acciones
                        </th>
                     </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                     {filteredContactos.map((contacto) => (
                        <tr key={contacto.id} className="hover:bg-gray-50">
                           <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                              {contacto.id}
                           </td>
                           <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                              {formatDate(contacto.created_at)}
                           </td>
                           <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                              {contacto.nombre}
                           </td>
                           <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                              <a
                                 href={`mailto:${contacto.email}`}
                                 className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
                              >
                                 <Mail className="w-3 h-3" />
                                 {contacto.email}
                              </a>
                           </td>
                           <td className="px-4 py-4 text-sm text-gray-900 max-w-xs">
                              <div
                                 className="truncate"
                                 title={contacto.consulta}
                              >
                                 {contacto.consulta.length > 50
                                    ? contacto.consulta.substring(0, 50) + "..."
                                    : contacto.consulta}
                              </div>
                           </td>
                           <td className="px-4 py-4 whitespace-nowrap">
                              <span
                                 className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                    contacto.response
                                       ? "bg-green-100 text-green-800"
                                       : "bg-yellow-100 text-yellow-800"
                                 }`}
                              >
                                 {contacto.response ? (
                                    <>
                                       <Check className="w-3 h-3 mr-1" />
                                       Respondido
                                    </>
                                 ) : (
                                    <>
                                       <X className="w-3 h-3 mr-1" />
                                       Pendiente
                                    </>
                                 )}
                              </span>
                           </td>
                           <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                              <div className="flex space-x-2">
                                 <button
                                    onClick={() =>
                                       setSelectedContacto(contacto)
                                    }
                                    className="text-blue-600 hover:text-blue-900 transition-colors"
                                    title="Ver detalles"
                                 >
                                    <Eye className="w-4 h-4" />
                                 </button>
                                 <button
                                    onClick={() => openResponseForm(contacto)}
                                    className="text-purple-600 hover:text-purple-900 transition-colors"
                                    title="Responder"
                                 >
                                    <MessageSquare className="w-4 h-4" />
                                 </button>
                                 <button
                                    onClick={() =>
                                       toggleResponse(
                                          contacto.id,
                                          contacto.response
                                       )
                                    }
                                    className={`transition-colors ${
                                       contacto.response
                                          ? "text-yellow-600 hover:text-yellow-900"
                                          : "text-green-600 hover:text-green-900"
                                    }`}
                                    title={
                                       contacto.response
                                          ? "Marcar como pendiente"
                                          : "Marcar como respondido"
                                    }
                                 >
                                    {contacto.response ? (
                                       <X className="w-4 h-4" />
                                    ) : (
                                       <Check className="w-4 h-4" />
                                    )}
                                 </button>
                              </div>
                           </td>
                        </tr>
                     ))}
                  </tbody>
               </table>
            </div>
         )}

         {/* Response Form Modal */}
         {showResponseForm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
               <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
                  <form onSubmit={sendResponse} className="p-6">
                     <div className="flex justify-between items-center mb-4">
                        <h2 className="text-2xl font-bold flex items-center gap-2">
                           <MessageSquare className="w-6 h-6" />
                           Responder Consulta
                        </h2>
                        <button
                           type="button"
                           onClick={() => setShowResponseForm(false)}
                           className="text-gray-400 hover:text-gray-600 text-2xl"
                        >
                           ×
                        </button>
                     </div>

                     {/* Contact Info */}
                     {(() => {
                        const contacto = contactos.find(
                           (c) => c.id === responseData.contactoId
                        );
                        return contacto ? (
                           <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                              <h3 className="font-semibold mb-2">
                                 Respondiendo a:
                              </h3>
                              <div className="grid grid-cols-2 gap-4 text-sm">
                                 <div>
                                    <span className="font-medium">Nombre:</span>{" "}
                                    {contacto.nombre}
                                 </div>
                                 <div>
                                    <span className="font-medium">Email:</span>{" "}
                                    {contacto.email}
                                 </div>
                              </div>
                              <div className="mt-2">
                                 <span className="font-medium text-sm">
                                    Consulta original:
                                 </span>
                                 <p className="text-sm text-gray-600 mt-1 italic">
                                    "{contacto.consulta}"
                                 </p>
                              </div>
                           </div>
                        ) : null;
                     })()}

                     <div className="space-y-4">
                        <div>
                           <label className="block text-sm font-medium text-gray-700 mb-1">
                              Asunto *
                           </label>
                           <input
                              type="text"
                              name="subject"
                              value={responseData.subject}
                              onChange={handleResponseChange}
                              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                              placeholder="Asunto del email"
                              required
                              disabled={submitting}
                           />
                        </div>

                        <div>
                           <label className="block text-sm font-medium text-gray-700 mb-1">
                              Mensaje *
                           </label>
                           <textarea
                              name="message"
                              value={responseData.message}
                              onChange={handleResponseChange}
                              rows={8}
                              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                              placeholder="Escribe tu respuesta aquí..."
                              required
                              disabled={submitting}
                           />
                        </div>

                        {/* <div className="bg-blue-50 p-3 rounded-lg">
                           <p className="text-sm text-blue-800">
                              💡 <strong>Nota:</strong> Esta respuesta se
                              preparará y podrás enviarla a través de tu cliente
                              de email preferido.
                           </p>
                        </div> */}
                     </div>

                     <div className="flex justify-end gap-3 mt-6">
                        <button
                           type="button"
                           onClick={() => setShowResponseForm(false)}
                           className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                           disabled={submitting}
                        >
                           Cancelar
                        </button>
                        <button
                           type="submit"
                           className="px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-2"
                           disabled={submitting}
                        >
                           {submitting ? (
                              <>
                                 <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                                 Preparando...
                              </>
                           ) : (
                              <>
                                 <Send className="w-4 h-4" />
                                 Enviar Respuesta
                              </>
                           )}
                        </button>
                     </div>
                  </form>
               </div>
            </div>
         )}

         {/* Contact Detail Modal */}
         {selectedContacto && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
               <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                  <div className="p-6">
                     <div className="flex justify-between items-start mb-4">
                        <h2 className="text-2xl font-bold">
                           Detalle del Contacto #{selectedContacto.id}
                        </h2>
                        <button
                           onClick={() => setSelectedContacto(null)}
                           className="text-gray-400 hover:text-gray-600 text-2xl"
                        >
                           ×
                        </button>
                     </div>

                     <div className="space-y-4">
                        <div className="flex items-center gap-2 text-gray-600">
                           <Calendar className="w-4 h-4" />
                           <span className="font-medium">Fecha:</span>
                           <span>
                              {formatDate(selectedContacto.created_at)}
                           </span>
                        </div>

                        <div className="flex items-center gap-2 text-gray-600">
                           <User className="w-4 h-4" />
                           <span className="font-medium">Nombre:</span>
                           <span>{selectedContacto.nombre}</span>
                        </div>

                        <div className="flex items-center gap-2 text-gray-600">
                           <Mail className="w-4 h-4" />
                           <span className="font-medium">Email:</span>
                           <a
                              href={`mailto:${selectedContacto.email}`}
                              className="text-blue-600 hover:text-blue-800"
                           >
                              {selectedContacto.email}
                           </a>
                        </div>

                        <div>
                           <span className="font-medium text-gray-600">
                              Estado:
                           </span>
                           <span
                              className={`ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                 selectedContacto.response
                                    ? "bg-green-100 text-green-800"
                                    : "bg-yellow-100 text-yellow-800"
                              }`}
                           >
                              {selectedContacto.response ? (
                                 <>
                                    <Check className="w-3 h-3 mr-1" />
                                    Respondido
                                 </>
                              ) : (
                                 <>
                                    <X className="w-3 h-3 mr-1" />
                                    Pendiente
                                 </>
                              )}
                           </span>
                        </div>

                        <div>
                           <span className="font-medium text-gray-600 block mb-2">
                              Consulta:
                           </span>
                           <div className="p-4 bg-gray-50 rounded-lg">
                              <p className="text-gray-800 leading-relaxed">
                                 {selectedContacto.consulta}
                              </p>
                           </div>
                        </div>
                     </div>

                     <div className="flex justify-between items-center mt-6 pt-4 border-t">
                        <button
                           onClick={() => openResponseForm(selectedContacto)}
                           className="px-4 py-2 bg-purple-500 hover:bg-purple-600 text-white rounded-lg transition-colors flex items-center gap-2"
                        >
                           <MessageSquare className="w-4 h-4" />
                           Responder
                        </button>

                        <div className="flex gap-2">
                           <button
                              onClick={() =>
                                 toggleResponse(
                                    selectedContacto.id,
                                    selectedContacto.response
                                 )
                              }
                              className={`px-4 py-2 rounded-lg transition-colors flex items-center gap-2 ${
                                 selectedContacto.response
                                    ? "bg-yellow-500 hover:bg-yellow-600 text-white"
                                    : "bg-green-500 hover:bg-green-600 text-white"
                              }`}
                           >
                              {selectedContacto.response ? (
                                 <>
                                    <X className="w-4 h-4" />
                                    Marcar como Pendiente
                                 </>
                              ) : (
                                 <>
                                    <Check className="w-4 h-4" />
                                    Marcar como Respondido
                                 </>
                              )}
                           </button>

                           <button
                              onClick={() => setSelectedContacto(null)}
                              className="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg transition-colors"
                           >
                              Cerrar
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         )}
      </div>
   );
}
